import { createStore, applyMiddleware, compose } from "redux"
import rootReducer from "./reducers"
import thunk from "redux-thunk"

// Use the built-in devtools compose function if we have devtools running
// else, just the bog-standard compose
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

// a configure store function which creates our store, and sets up HMR reloading
const configureStore = () => {
  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunk))
  )

  if (process.env.NODE_ENV !== "production") {
    if (module.hot) {
      module.hot.accept("./reducers", () => {
        store.replaceReducer(rootReducer)
      })
    }
  }

  return store
}

export default configureStore
